<div class="rest-of w-n-100 p-r-20 simple-scroll full-grow-no-shrink-no-basis">
  <particle-comment-box
    [contextId]="contextId"
    [scope]="scopeInt"
    sourceType="'TM'"
    title="'TM'"
    [messageType]="messageType"
    [bringIntoView]="true"
    [conversationType]="conversationType"
  ></particle-comment-box>
</div>
